export default "__VITE_ASSET__72d705d9__"